import { useSelector } from 'react-redux';
import { RootState } from 'shared';
import { useAuth } from 'shared/auth';

export const useCheckRoleAccess = () => {
    const { authService } = useAuth();
    const { dataGeneralParameters } = useSelector(
        (state: RootState) => state.invoiceData
    );

    const checkRoles = (authorizedRoles: string[]): boolean => {
        const userRoles = authService.getUserRoles();
        return userRoles.some(role => authorizedRoles.includes(role));
    }

    const isAssignedUser = () => {
        const currentUser = authService.getUser()?.oid;
        const userString = dataGeneralParameters[0]?.content?.currentUser as unknown as { id: string };
        const assignedUser = userString?.id;
        return currentUser === assignedUser;
    };

    return {
        checkRoles,
        isAssignedUser
    }
}
